import { signal } from '@preact/signals-core';

// Initialize a signal for the current path
export const currentPath = signal(window.location.pathname);

// Listen to history changes to update the path signal
window.addEventListener('popstate', () => {
    currentPath.value = window.location.pathname;
});
